import { loanData } from "../components/LoanData";

var interests;
var secondInterests;
var invoiceFee;
var secondInvoiceFee = null;
var debitorInterest = 0.1495;
var startUpFee = 1.00;
var totalCreditCostPrMonth = 514;
var secondTotalCreditCostPrMonth = 514;
var monthlyInterest = interests / 12;
var totalCreditCost = null;
var secondTotalCreditCost = null;
var hovedStol = null;
var loanAmount;
var loanDurationInMonths;

export function calculateMonthlyPaymentAmount(
  loanAmount: number,
  loanDuration: number
) {
    return loanData.find(data => data.amount == loanAmount.toString() && data.month == loanDuration.toString()).monthlyPay
}



function irr(loanamountToIrr, amortization, periods) {
    var p = 1;
    var tmp = 1;
    var a = p;
    var b = 0;

    while (Math.abs(tmp) > 0.0001) {
        p = (a - b) / 2 + b;
        tmp = (loanamountToIrr / amortization) - (1 - Math.pow(1 + p, -periods)) / p;
        if (tmp > 0) {
            a = p;
        } else {
            b = p;
        }
    }
    var irr = Math.pow((1 + p), 12) - 1;
    return irr;
}